import React from 'react';
import styled from 'styled-components';
import { fontWeight } from '@grnhse/seedling/lib/azalea/constants';
import FormSubmitButtons from '@grnhse/seedling/lib/azalea/components/form_submit_buttons';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/components/ControlledModal'. 'app/webpack/javascripts/shared/components/ControlledModal.js' implicitly has an 'any' type.
import ControlledModal from 'shared/components/ControlledModal';
import t from 'shared/utils/translation';

type Props = {
  buttonText: string;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (arg1: React.SyntheticEvent<HTMLButtonElement>) => void;
  text: string;
  title: string;
};

const ToggleWarningModal = (props: Props) => {
  const { buttonText, isOpen, onCancel, onConfirm, text, title } = props;

  return (
    <ControlledModal
      draggable={false}
      isOpen={isOpen}
      onRequestClose={onCancel}
      title={title}
      width={443}
    >
      <Text>{text}</Text>
      <FormSubmitButtons
        onCancel={onCancel}
        onSubmit={onConfirm}
        submitText={buttonText}
        cancelText={t('gdpr.invalid_modal.cancel')}
        fancy={true}
      />
    </ControlledModal>
  );
};

export default ToggleWarningModal;

const Text = styled.div`
  font-size: 14px;
  font-weight: ${fontWeight.normal};
  line-height: 24px;
`;
